import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';

export const isAdminOrClientAdminGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const nav = inject(NavigationService);

	const isAdmin: boolean = await authService.isAdmin$();
	const isClientAdmin: boolean = await authService.isClientAdmin$();

	if (isAdmin || isClientAdmin) {
		return true;
	} else {
		nav.navigate(['/']);
		return false;
	}
};
